import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getAwardOptions } from '@/module/Author/Award';
import { AwardEdit } from '@/module/Author/Award/AwardEdit';

export const Route = createFileRoute('/_auth/author/_author/award/_award/$awardId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { awardId } = Route.useParams();
  const { data: award } = useSuspenseQuery(getAwardOptions(awardId));

  return <AwardEdit award={award} />;
}
